<template>
  <div class="interferometer-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>φ = 2π·ΔL / λ | 高精度相位检测$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Light Source -->
          <line x1="20" y1="60" x2="60" y2="60" stroke="#fff" stroke-width="4" />
          
          <!-- Beam Splitter 1 -->
          <g transform="translate(60, 60)">
             <line x1="-15" y1="-15" x2="15" y2="15" stroke="#00d2ff" stroke-width="2" />
             <text x="5" y="-10" fill="#0分a" font-size="8">BS1 (分束)</text>
          </g>

          <!-- Path 1 (Top) -->
          <path d="M 60,60 L 300,60 L 300,180" fill="none" stroke="rgba(255,255,255,0.2)" stroke-width="2" />
          
          <!-- Path 2 (Bottom) -->
          <path d="M 60,60 L 60,180 L 300,180" fill="none" stroke="rgba(255,255,255,0.2)" stroke-width="2" />

          <!-- Test Sample (Phase shifter) -->
          <g transform="translate(150, 45)">
             <rect width="40" height="30" fill="rgba(0, 210, 255, 0.2)" stroke="#00d2ff" />
             <text x="5" y="45" fill="#00d2ff" font-size="8">待测样品</text>
          </g>

          <!-- Beam Splitter 2 (Recombination) -->
          <g transform="translate(300, 180)">
             <line x1="-15" y1="-15" x2="15" y2="15" stroke="#00d2ff" stroke-width="2" />
             <text x="15" y="25" fill="#00d2ff" font-size="8">BS2 (合束)</text>
          </g>

          <!-- Interference Result (Detector) -->
          <g transform="translate(350, 180)">
             <circle r="20" :fill="interColor" />
             <text y="40" text-anchor="middle" fill="#888" font-size="8">周期性相干条纹</text>
          </g>

          <!-- Wave phase animation -->
          <path :d="`M 60,60 L 300,60`" fill="none" stroke="#ff4757" stroke-dasharray="10, 10">
             <animate attributeName="stroke-dashoffset" :from="0" :to="100" :dur="`${2/(phase+1)}s`" repeatCount="indefinite" />
          </path>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>相位位移 Δφ: {{ (phase * 360).toFixed(0) }}°</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节样品厚度 (相位)</label>
             <el-slider v-model="phase" :min="0" :max="1" :step="0.01" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>马赫-曾德尔干涉仪通过将光束分为两条独立的路径，并在终点重新合并来检测相位差。与迈克尔逊干涉仪不同，光在每条路径上只通过一次。即使其中一条路径中的介质发生极微弱的变化（如压力或温度导致折射率改变），也会引起严重的**干涉相长或相消**。它常用于空气动力学、高速等离子体诊断及量子光学实验。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MachZehnderViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      phase: 0.2
    }
  },
  computed: {
    interColor() {
       let intensity = (Math.cos(this.phase * Math.PI * 2) + 1) / 2;
       return `rgba(255, 255, 255, ${0.1 + intensity * 0.9})`;
    }
  }
}
</script>

<style scoped lang="scss">
.interferometer-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
